import secondsToFormattedString from "utils/helpers/secondsToFormattedString/secondsToFormattedString";

export default secondsToFormattedString;
